import React from 'react'
import styled from '@emotion/styled'

import SearchBar from '../../base/SearchBar'
import SortBar from '../../base/SortBar'
import ViewBar from '../../base/ViewBar'

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 21px;
`

const SearchBarBin = styled.div`
  flex: 1;
  margin-right: 25px;
`

const ViewBarBin = styled.div`
  flex-shrink: 0;
  margin-right: 25px;
  padding-top: 2px;
`

const SortBarBin = styled.div`
  flex-shrink: 0;
  margin-right: -3px;
`

const CatalogTopBar = ({
  activeCatalogType,
  activeCategory,
  searchQuery,
  setSearchQuery,
  viewType,
  setViewType,
  sortOptions,
  sort,
  setSort,
}) => <Root>
  <SearchBarBin>
    <SearchBar
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      placeholder={activeCatalogType.getSearchPlaceholder(activeCategory)}
    />
  </SearchBarBin>
  <ViewBarBin>
    <ViewBar viewType={viewType} setViewType={setViewType}/>
  </ViewBarBin>
  <SortBarBin>
    <SortBar options={sortOptions} sort={sort} setSort={setSort}/>
  </SortBarBin>
</Root>

export default CatalogTopBar
